import { render } from "./menumanagement.vue?vue&type=template&id=4c191e24&scoped=true"
import script from "./menumanagement.vue?vue&type=script&lang=js"
export * from "./menumanagement.vue?vue&type=script&lang=js"

import "./menumanagement.vue?vue&type=style&index=0&id=4c191e24&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4c191e24"

export default script